import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { finalizeClaim } from "../../firebase/db.js";
import { useAuth } from "../auth/AuthContext.jsx";

// Runs after sign-in. Reads the stashed claimToken and finalizes ownership,
// then drops the user into the wizard/editor for their new event.
export default function ClaimFinish() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [status, setStatus] = useState("Finalizing your link…");

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate(`/app/claim/${slug}`, { replace: true }); return; }

    const token = sessionStorage.getItem(`einvite:token:${slug}`);
    (async () => {
      try {
        if (token) {
          await finalizeClaim(slug, token);
          sessionStorage.removeItem(`einvite:token:${slug}`);
        }
        navigate(`/app/edit/${slug}`, { replace: true });
      } catch (e) {
        setStatus(`Couldn't finalize: ${e.message}`);
      }
    })();
  }, [loading, user]); // eslint-disable-line

  return (
    <div className="container center" style={{ paddingTop: 120 }}>
      <p className="muted">{status}</p>
    </div>
  );
}
